import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
// 다국어
import { useTranslation } from 'react-i18next';
// @mui
import { alpha, styled } from '@mui/material/styles';
import { Box, Divider, Typography, Stack, MenuItem, Avatar, IconButton, Popover } from '@mui/material';
// mocks_
import account from '../../../_mock/account';

// ----------------------------------------------------------------------



const SPAN = styled('span')(({ theme }) => ({
  backgroundColor:'#1A9EF8', 
  borderRadius:'5px', 
  color:'#fff', 
  padding:'3px 10px', 
  textAlign:'center', 
  width:'fit-content'
}));
// ----------------------------------------------------------------------


export default function AccountPopover() {
  // 다국어
const { t, i18n } = useTranslation(['page']);

const MENU_OPTIONS = [
  {
    label: t('마이페이지'),
    icon: 'eva:person-fill',
  },
];

  const navigate = useNavigate();
  const [open, setOpen] = useState(null);
  
  // const [login, isLogin] = useState('로그아웃');

  // useEffect(() => {
  //   if(sessionStorage.getItem('login_info')){
  //     isLogin('로그아웃')
  //   }else{
  //     alert('사용자 정보 불러오기 오류')
  //   }
  // }, []);


  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(null);
  };

  const handleCloseLogout = () => {
    setOpen(null);
    sessionStorage.removeItem('login_info');
    sessionStorage.removeItem('org_id');
    navigate('/login', { replace: true });
  };

  const gotoMypage = () => {
    setOpen(null);
    navigate('/mypage', { replace: true });

  }

  const gotoLogin = () => {
    setOpen(null);
    navigate('/login', { replace: true });

  }

  // ------------------------------------------------------------------

  

  return (
    <>
      <IconButton
        onClick={handleOpen}
        sx={{
          p: 0,
          ...(open && {
            '&:before': {
              zIndex: 1,
              content: "''",
              width: '100%',
              height: '100%',
              borderRadius: '50%',
              position: 'absolute',
              bgcolor: (theme) => alpha(theme.palette.grey[900], 0.8),
            },
          }),
        }}
      >
        <Avatar src={account.photoURL} alt="photoURL" />
      </IconButton>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 0,
            mt: 1.5,
            ml: 0.75,
            width: 220,
            '& .MuiMenuItem-root': {
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        <Box sx={{ my: 1.5, px: 2.5 }}>
          <Typography variant="subtitle1" noWrap>
          { JSON.parse(sessionStorage.getItem('login_info')).user_name }
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
          { JSON.parse(sessionStorage.getItem('login_info')).login_id }
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
            { JSON.parse(sessionStorage.getItem('login_info')).use_license === 'N/A' ?
          null : <SPAN>
            {t(JSON.parse(sessionStorage.getItem('login_info')).use_license)}</SPAN>
          
          }
          </Typography>
        </Box>

        <Divider sx={{ borderStyle: 'dashed' }} />

        <Stack sx={{ p: 1 }}>
          {MENU_OPTIONS.map((option) => (
            <MenuItem key={option.label} onClick={() => { gotoMypage()}}>
              {option.label}
            </MenuItem>
          ))}
        </Stack>

        <Divider sx={{ borderStyle: 'dashed' }} />
        
         <MenuItem onClick={handleCloseLogout} sx={{ m: 1 }}>
        
          {t('로그아웃')}
        </MenuItem> 
        
      </Popover>
    </>
  );
}
